/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'external-hover': {
    width: 28,
    height: 27,
    viewBox: '0 0 28 27',
    data: '<path pid="0" d="M7.322 5.089c1.796-.85 3.789-1.18 5.755-.963a.68.68 0 01.582.807c-.07.388-.441.644-.834.605a9.278 9.278 0 00-9.02 4.7A9.276 9.276 0 009.837 23.81a9.274 9.274 0 0011.336-8.899c.006-.394.303-.735.697-.76a.68.68 0 01.734.672 10.71 10.71 0 01-6.589 9.827A10.707 10.707 0 017.322 5.09zm20.415 1.472a.673.673 0 01-1.345 0V2.296L12.473 16.215a.671.671 0 11-.95-.95l13.921-13.92h-4.267a.672.672 0 010-1.345h6.56v6.56z" _fill="#0077C8"/>'
  }
})
